export const COMMON_REQ = 'cris/alertLibrary/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/alertLibrary/COMMON_REQ_FAIL';

export const LOAD_ALERT_LIBRARIES_SUCCESS = 'cris/alertLibrary/LOAD_ALERT_LIBRARIES_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	alertLibraries: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_ALERT_LIBRARIES_SUCCESS:
			const alertLibraries = action.payload.data.alert_libraries.map((item) => ({
				id: item.id,
				name: item.name,
				icon: item.icon || '',
				icon_url: item.icon_url || '',
				flash_color: item.flash_color || '',
				status: item.status
			}));

			return {
				...state,
				isLoading: false,
				alertLibraries: alertLibraries
			};

		default:
			return state;
	}
}
